'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaPassengers = function () {
  function WinresOmalomaPassengers($rootScope, $scope, omalomaService, $q) {
    var _this = this;

    _classCallCheck(this, WinresOmalomaPassengers);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.omalomaService = omalomaService;
    this.selectedId = -1;
    this.passengerEditEnabled = false;
    this.$q = $q;

    // Current status. Possible values:
    // init - Initializing.
    // out - Not logged in.
    // waiting_for_parameter - Waiting for a dynamic parameter to be set.
    // loading - Loading info.
    // ready - Info loaded.
    // error - Failed to load info.
    this.setStatus('init', null);

    $scope.$watch(function () {
      return _this.bookingNumber;
    }, function () {
      return _this.update();
    });
  }

  _createClass(WinresOmalomaPassengers, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.$rootScope.$on('login', function () {
        return _this2.update();
      });
      this.$rootScope.$on('logout', function () {
        return _this2.setStatus('out', null);
      });
      //this.$scope.$watch(() => this.bookingNumber, () => this.update()); // (?) commented to prevent double load, uncomment if something breaks.
      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.update();
      } else {
        this.setStatus('out', null);
      }
      this.getCustomerNumber();
    }
  }, {
    key: 'getPassengerFieldSettings',
    value: function getPassengerFieldSettings() {
      var _this3 = this;

      this.omalomaService.getDestinationInfo(this.bookingNumber).then(function (result) {
        _this3.passengerFieldSettings = result.PassengerFieldSettings;
      });
    }
  }, {
    key: 'getCustomerNumber',
    value: function getCustomerNumber() {
      var _this4 = this;

      this.omalomaService.getCustomerNumber(this.bookingNumber).then(function (result) {
        _this4.customerNumber = result;
      });
    }
  }, {
    key: 'getPassengerEditStatus',
    value: function getPassengerEditStatus() {
      var _this5 = this;

      this.passengerEditEnabled = false;

      var user = this.omalomaService.userService.getCurrentUser();
      var allowPassengerChanges = user.loginResult.Office.Settings.AllowPassengerChanges;

      var promises = [this.omalomaService.getCustomerBookingBalance(this.bookingNumber), this.omalomaService.getCustomerReservableExtraServices(this.bookingNumber)];

      this.$q.all(promises).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            balance = _ref2[0],
            extraServices = _ref2[1];

        // Booking invoices total price does not match with booking total price.
        // Prevent changes in passengers. 
        var bookingInProcess = balance.Error === 'InvalidTotal';

        _this5.passengerEditEnabled = (extraServices.ReservableExtraServices.length === 0 || extraServices.ReservableExtraServices[0].ReservabilityCheckResults.BookingDepartureClosingDate == true) && allowPassengerChanges == true && bookingInProcess === false;

        if (bookingInProcess === true) {
          _this5.setStatus('booking_in_process', null);
        } else if (_this5.passengerEditEnabled || _.some(_this5.$scope.passengers, function (passenger) {
          return passenger.FirstName;
        })) {
          _this5.setStatus('ready', null);
        } else {
          _this5.setStatus('no_passengers', null);
        }
      });
    }
  }, {
    key: 'selectPassenger',
    value: function selectPassenger(id) {
      var _this6 = this;

      if (!this.omalomaService.isLoggedInAsCustomer()) {
        console.log("[WOP] Passenger editing permitted: not logged in.");
        return;
      }

      if (!this.passengerEditEnabled || this.passengerEditEnabled == false) {
        console.log("[WOP] Passenger editing not enabled!");
        return;
      }

      if (this.selectedId != -1) {
        console.log("[WOP] Passenger module already exists!");
        return;
      }

      this.getPassengerFieldSettings();

      // Select from existing passenger array. No request.
      var passengers = this.$scope.passengers;
      _.each(passengers, function (passenger) {
        if (passenger.Number == id) {
          _this6.selectedId = passenger.Number;

          // editPassenger is used for viewing and saving properties. Number = id.
          // Spawning this.$scope.editPassenger opens passenger edit module.
          _this6.$scope.editPassenger = { Number: passenger.Number, Gender: passenger.Gender, FirstName: passenger.FirstName, LastName: passenger.LastName, Email: passenger.Email, MobileNo: passenger.MobileNo, StreetAddress: passenger.City, PostAddress: passenger.PostAddress };

          _this6.customerEditModal = document.getElementById("customer-edit-modal");
          document.body.appendChild(_this6.customerEditModal); // Module appears at front of every element.
        }
      });

      // With request.
      /*this.omalomaService.getPassengers(this.bookingNumber).then(passengers => {
      	var i = 0;
      	for(i=0;i<passengers.length;i++){
      		if(passengers[i].Number==id){
      			var passenger = passengers[i];
      			this.selectedId = passengers[i].Number;
      				// editPassenger is used for viewing and saving properties. Number = id.
      			this.$scope.editPassenger = {Number: passenger.Number, Gender: passenger.Gender, FirstName: passenger.FirstName, LastName: passenger.LastName, Email: passenger.Email, MobileNo: passenger.MobileNo, StreetAddress: passenger.City, PostAddress: passenger.PostAddress};
      				//this.$scope.editPassenger = {Number: passenger.Number, Gender: passenger.Gender, FirstName: passenger.FirstName, LastName: passenger.LastName, BirthDate: passenger.DateofBirth};
      				this.customerEditModal = document.getElementById("customer-edit-modal");		
      			document.body.appendChild(this.customerEditModal); // Module appears at front of every element.
      			break;
      		}
      	}
      	}).catch(error => {
      		console.error('[WOP] Failed to get passengers for', this.bookingNumber,
      			':', error);
      		this.setStatus('error', 'malfunction');
      	});*/
    }
  }, {
    key: 'savePassengerProperties',
    value: function savePassengerProperties() {
      var _this7 = this;

      this.setStatus('loading', null);

      if (this.omalomaService.isLoggedInAsCustomer() && this.passengerEditEnabled && this.passengerEditEnabled == true) {
        var editPassenger = this.$scope.editPassenger;

        var passengerProperties = {};
        passengerProperties.Number = editPassenger.Number; // id.

        // Save only asked properties.
        for (var k in this.passengerFieldSettings) {
          if (this.passengerFieldSettings[k].Ask == true) passengerProperties[k] = editPassenger[k];
        }

        this.omalomaService.updatePassenger(this.customerNumber, this.bookingNumber, passengerProperties); // Save.
        console.log("[WOP] Saved passenger " + this.selectedId, passengerProperties);

        var passengers = this.$scope.passengers;
        _.each(passengers, function (passenger) {
          if (passenger.Number == _this7.selectedId) {
            for (var k in passenger) {
              passenger[k] = editPassenger[k];
            } // Set all properties to selected passenger.
          }
        });
        console.log("[WOP] Loaded passenger " + this.selectedId, editPassenger);
        this.$scope.passengers = passengers;
      }

      this.selectedId = -1;
      this.$scope.editPassenger = undefined; // Close passenger edit module.
      this.setStatus('ready', null);
    }
  }, {
    key: 'cancelPassengerProperties',
    value: function cancelPassengerProperties() {
      this.selectedId = -1;
      this.$scope.editPassenger = undefined; // Close passenger edit module.
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$scope.passengers = [];
    }
  }, {
    key: 'update',
    value: function update() {
      var _this8 = this;

      if (!this.bookingNumber) {
        console.log('[WOP] Booking number not available yet.');
        this.setStatus('waiting_for_parameter', null);
        this.reset();
        return;
      }

      this.getPassengerFieldSettings();
      this.setStatus('loading', null);
      this.omalomaService.getPassengers(this.bookingNumber).then(function (response) {
        if (response.length === 0) {
          console.info("Received no passengers. This is probably not a departure then...");
          _this8.setStatus('no passengers', null);
        } else {
          console.log('[WOP] Got passengers:', response);
          _this8.$scope.passengers = response;
          _this8.getPassengerEditStatus();
          //this.setStatus('ready', null);
        }
      }).catch(function (error) {
        console.error('[WOP] Failed to get passengers for', _this8.bookingNumber, ':', error);
        _this8.reset();
        _this8.setStatus('error', 'malfunction');
      });
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, error) {
      this.$scope.status = status;
      console.log('[WODI] Set status to', status);
      if (error !== undefined) {
        if (error) {
          console.log('[WODI] Error:', error);
          this.$scope.error = error;
        }
      }
    }
  }]);

  return WinresOmalomaPassengers;
}();

WinresOmalomaPassengers.$inject = ['$rootScope', '$scope', 'omalomaService', '$q'];

_module3.default.component('winresOmalomaPassengers', {
  template: require('./winresOmalomaPassengers.html'),
  controller: WinresOmalomaPassengers,
  bindings: {
    bookingNumber: '<'
  },
  require: {}
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaPassengers/winresOmalomaPassengers.js
// module id = 355
// module chunks = 2